// extracted by mini-css-extract-plugin
export default {"button":"tq-z","reviewSort":"uq-z"};